const e = window.__env__ || {};
export const REACT_APP_API_URL = e.REACT_APP_API_URL || process.env.REACT_APP_API_URL || "";
